import { OBJECT_URL_REVOKE_DELAY_MS } from 'constants/uiSettings';

export const isBlobObjectUrl = (url: string | null | undefined): boolean => {
  return !!url && url.startsWith('blob:');
};

export const isDataUrl = (url: string | null | undefined): boolean => {
  return !!url && url.startsWith('data:');
};

export const isHttpUrl = (url: string | null | undefined): boolean => {
  return /^https?:\/\//i.test((url || '').trim());
};

export const revokeObjectUrl = (url: string | null | undefined): void => {
  if (!url || !isBlobObjectUrl(url)) return;
  window.URL.revokeObjectURL(url);
};

export const scheduleRevokeObjectUrl = (
  url: string | null | undefined,
  delayMs = OBJECT_URL_REVOKE_DELAY_MS
): void => {
  if (!isBlobObjectUrl(url)) return;
  window.setTimeout(() => revokeObjectUrl(url), delayMs);
};
